import { motion } from "framer-motion";
import { RESTAURANT_INFO } from "@/data/menuData";

export const HistorySection = () => {
  return (
    <section data-testid="history-section" className="relative bg-[#2B3618] overflow-hidden">
      {/* Grain texture overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
      }} />

      <div className="relative max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <span className="font-['DM_Sans'] text-xs md:text-sm uppercase tracking-[0.25em] font-bold text-[#C41E3A]">
            Desde 2015
          </span>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl md:text-5xl font-bold text-[#F5F5F5] mt-4 tracking-tight">
            {RESTAURANT_INFO.history.title}
          </h2>
          <div className="w-16 h-1 bg-[#C41E3A] rounded-full mx-auto mt-6" />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-['DM_Sans'] text-base md:text-lg text-[#F5F5F5]/85 leading-relaxed text-center mt-8 max-w-2xl mx-auto"
        >
          {RESTAURANT_INFO.history.text}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 grid grid-cols-3 gap-6 max-w-lg mx-auto"
        >
          <div className="text-center">
            <span className="block font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#C41E3A]">30+</span>
            <span className="block font-['DM_Sans'] text-xs text-[#F5F5F5]/60 mt-1 uppercase tracking-wider">Años de experiencia</span>
          </div>
          <div className="text-center">
            <span className="block font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#C41E3A]">11</span>
            <span className="block font-['DM_Sans'] text-xs text-[#F5F5F5]/60 mt-1 uppercase tracking-wider">Años en sucursal</span>
          </div>
          <div className="text-center">
            <span className="block font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#C41E3A]">50+</span>
            <span className="block font-['DM_Sans'] text-xs text-[#F5F5F5]/60 mt-1 uppercase tracking-wider">Platillos en menú</span>
          </div>
        </motion.div>

        {/* History transition image */}
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="mt-14 max-w-md mx-auto"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_adrianoz-delivery/artifacts/b4iu64vs_IMG_0280.png"
            alt="De Alonso's Pizza a Adrianoz Pizza - Nuestra evolucion"
            className="w-full rounded-2xl shadow-2xl shadow-black/30 border-2 border-white/10"
            data-testid="history-transition-image"
          />
        </motion.div>
      </div>
    </section>
  );
};
